import React, { memo } from 'react';
import clsx from 'clsx';
import { Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import BasicTextField from '../TextField/BasicTextField';

const styles = (theme: Theme) => {
  return createStyles({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      width: '100%',
    },
  });
};

export interface ITimePickerProps extends WithStyles<typeof styles> {
  id: string;
  customStyles?: any;
  value?: React.ReactNode;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  label?: React.ReactNode;
  type?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  placeholder?: string;
  disabled?: boolean;
}

const TimePicker = ({
  classes,
  id,
  customStyles,
  onChange,
  value,
  label,
  placeholder,
  helperText = '',
  error = false,
  type = 'time',
  disabled = false,
}: ITimePickerProps) => {
  return (
    <form
      className={clsx(classes.container, customStyles && customStyles)}
      noValidate
    >
      <BasicTextField
        customStyles={classes.textField}
        id={id}
        // defaultValue={moment(new Date()).format('YYYY-MM-DDTHH:mm')}
        label={label}
        value={value}
        onChange={onChange}
        type={type}
        helperText={error && helperText}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
        InputLabelProps={{
          shrink: true,
        }}
        // inputProps={{
        //   step: 300, // 5 min
        // }}
      />
    </form>
  );
};

export default memo(withStyles(styles)(TimePicker));
